/**
 * Cart Free Gift – FINAL (Symmetry-safe)
 */

(() => {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);

  function money(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function readConfig() {
    const el = document.getElementById('free-gift-config');
    if (!el) return null;

    return {
      threshold: Number(el.dataset.threshold),
      variantId: String(el.dataset.variantId),
      title: el.dataset.title || 'Free gift'
    };
  }

  function compute(cart, giftVariantId) {
    let giftTotal = 0;
    let giftPresent = false;

    cart.items.forEach(item => {
      if (String(item.variant_id) === giftVariantId) {
        giftPresent = true;
        giftTotal += item.final_line_price;
      }
    });

    const subtotalExGift = Math.max(
      0,
      cart.items_subtotal_price - giftTotal
    );

    return { subtotalExGift, giftPresent };
  }

  function render(cart, cfg) {
    const wrap = $('.cart-gift-progress-wrap');
    if (!wrap) return;

    const perk = $('.cart-gift-perk', wrap);
    const title = $('.cart-gift-perk__title', wrap);
    const subtitle = $('.cart-gift-perk__subtitle', wrap);
    const fill = $('.gift-progress-bar__fill', wrap);

    const { subtotalExGift, giftPresent } = compute(cart, cfg.variantId);

    const remaining = Math.max(0, cfg.threshold - subtotalExGift);
    // 🚫 ENFORCE RULE: remove gift if threshold not met
    if (remaining > 0 && giftPresent) {
      removeGift(cfg.variantId).then(() => {
        document.dispatchEvent(
          new CustomEvent('dispatch:cart-drawer:refresh')
        );
      });
      return;
    }

    const percent = cfg.threshold > 0
    ? Math.min(100, Math.round((subtotalExGift / cfg.threshold) * 100))
    : 0;


    if (fill) fill.style.width = `${percent}%`;

    if (remaining > 0) {
      perk.classList.add('cart-gift-perk--locked');
      perk.classList.remove('cart-gift-perk--unlocked');

      title.textContent = 'Unlock Free Gift';
      subtitle.innerHTML = `You're <strong>${money(remaining)}</strong> away`;

      const btn = $('.cart-gift-add-btn', wrap);
      if (btn) btn.remove();
      return;
    }

    perk.classList.remove('cart-gift-perk--locked');
    perk.classList.add('cart-gift-perk--unlocked');

    title.textContent = 'Free Gift Unlocked';

    if (giftPresent) {
      subtitle.textContent = 'Free gift already added to your cart';
      const btn = $('.cart-gift-add-btn', wrap);
      if (btn) btn.remove();
      return;
    }

    subtitle.innerHTML = `
      <button
        type="button"
        class="btn btn--small btn--secondary cart-gift-add-btn"
        data-variant-id="${cfg.variantId}">
        Add free gift
      </button>
    `;
  }

  async function refresh() {
    const cfg = readConfig();
    if (!cfg) return;

    const cart = await getCart();
    render(cart, cfg);
  }

   async function removeGift(variantId) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      });
    }

  // 🔁 ONE refresh source – Symmetry-safe
  document.addEventListener('on:cart:after-merge', refresh);
  document.addEventListener('dispatch:cart-drawer:refresh', refresh);

  // Add gift
  document.addEventListener('click', async e => {
    const btn = e.target.closest('.cart-gift-add-btn');
    if (!btn) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
    });

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
  });

})();
